if (!customElements.get('custom-expand-product')) {
  customElements.define(
    'custom-expand-product',
    class CustomExpandProduct extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton;

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        // ✅ QUANTITY ELEMENTS ADDED HERE
        this.minusBtn = this.querySelector('.expant-quantity_minus');
        this.plusBtn = this.querySelector('.expant-quantity_plus');
        this.quantityInput = this.querySelector('input[name="quantity"]');

        if (this.minusBtn && this.plusBtn && this.quantityInput) {
          this.minusBtn.addEventListener('click', () => {
            let val = parseInt(this.quantityInput.value || 1);
            if (val > 1) this.quantityInput.value = val - 1;
          });

          this.plusBtn.addEventListener('click', () => {
            let val = parseInt(this.quantityInput.value || 1);
            this.quantityInput.value = val + 1;
          });
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // optional Dawn cart sections support
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('Cart error:', response);

              this.handleLoading(false);
              return;
            }

            // update cart drawer / notification (Dawn style)
            if (this.cart && response) {
              this.cart.renderContents(response);
            }

            this.handleLoading(false);
          })
          .catch((err) => {
            console.error('Add to cart failed:', err);
            this.handleLoading(false);
          });
      }

      handleLoading(state) {
        if (!this.submitButton) return;

        if (state) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
        }
      }
    }
  );
}